<script setup lang="ts">
/**
 * StatusBadge — maps ConnectionStatus onto the design-system Badge variants.
 * The design system has no "info" variant, so `connecting` (previously
 * info-colored) maps to the neutral "secondary" variant.
 */
import { computed } from 'vue';
import { Badge } from '@design-system/vue-ui';

const props = defineProps<{
  status: 'connected' | 'disconnected' | 'connecting' | 'error' | string;
}>();

type BadgeVariant = 'default' | 'destructive' | 'outline' | 'secondary' | 'success' | 'warning';

const STATUS_TO_BADGE_VARIANT: Record<string, BadgeVariant> = {
  connected: 'success',
  disconnected: 'warning',
  connecting: 'secondary',
  error: 'destructive',
};

const variant = computed<BadgeVariant>(() => STATUS_TO_BADGE_VARIANT[props.status] ?? 'default');
</script>

<template>
  <Badge :variant="variant">{{ status }}</Badge>
</template>
